<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><span class="org">Dedication</span></p>
<p class="noindent">I owe a great deal of gratitude to the many quilters who supported me throughout this process—their combined friendship, inspiration, guidance, and creativity have helped me with the making of this book.</p>
<p class="noindent">To my husband of 50-plus years, Fred: I can’t express in words how you have stood by me all these years. Obviously, without you I would not be where I am today.</p>
<p class="noindent">To my dear daughter, Lisa, who is always willing to collaborate on new designs: Thank you for your guidance in color and composition, and your most valuable help in creating the perfect graphics. Thanks also to my son-in-law, Brian, for sharing her with me, as she has spent hours and hours on this.</p>
<p class="noindent">To my son, Michael; his wife, Stacey; and my grandsons, Nate and Tim: Thanks for all the encouragement, support, and computer expertise. I love you all dearly.</p>
<p class="noindent">To my dear friend Jean Hall: You are always there for me. Thank you for your friendship, knowledge, writing skills, and guidance.</p>
<p class="noindent">To my lifelong friend Connie Barry, who gave me the courage and help to write quilting books: Thank you for always being willing to read a rough draft.</p>
<p class="noindent">To my critique group, Fiber Visions: Without all your help, guidance, and friendship I would not be the fiber artist I am today.</p>
<p class="noindent">Last, but certainly not least, to my friends Judy Sabourin and Carol Ayotte: I owe you two a world of gratitude for your friendship and willingness to take a chance on any new concept or idea. I would not have been able to pull this off without your support and creativity. Thank you so much for our weeks on Cape Cod, just brainstorming and creating.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1e513e0c